import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { TypeIndexEnum } from 'src/app/domain/registration/enums/type-index.enum';
import { GlobalUtils } from 'src/app/shared/global-utils';
import { GlobalConfigCesComponent } from '../global-config/crud-ces/crud-ces.component';

@Component({
  selector: 'app-financial-settings',
  templateUrl: './financial-settings.component.html',
  styleUrls: ['./financial-settings.component.scss']
})
export class FinancialSettingsComponent implements OnInit {
  @Input() moduleType: 'accounts-payable' | 'accounts-receivable' | 'pass-on' | 'account-types' | 'account-movimentations' = 'accounts-payable';
  @Input() dialogRef: MatDialogRef<any>;

  constructor(
    protected router: Router,
    protected dialog: MatDialog,
    protected fb: FormBuilder
  ) { }

  ngOnInit(): void {
  }

  openLink(link: string): void {
    this.router.navigate([link]);
    if (this.dialogRef) {
      this.dialogRef.close();
    }
  }

  goToPaymentTypes(): void {
    const url = this.router.serializeUrl(
      this.router.createUrlTree(['payment-methods'], {
        queryParams: { moduleType: this.moduleType }
      })
    );
    window.open(url, '_blank');

    if (this.dialogRef) {
      this.dialogRef.close();
    }
  }


  goToAccountTypes(): void {
    const url = this.router.serializeUrl(
      this.router.createUrlTree(['account-types'], {
        queryParams: { moduleType: this.moduleType }
      })
    );
    window.open(url, '_blank');

    if (this.dialogRef) {
      this.dialogRef.close();
    }
  }

  goToAccountMovimentations(): void {
    const url = this.router.serializeUrl(
      this.router.createUrlTree(['account-movimentations'], {
        queryParams: { moduleType: this.moduleType }
      })
    );
    window.open(url, '_blank');

    if (this.dialogRef) {
      this.dialogRef.close();
    }
  }

  goToGlobalConfig(): void {
    GlobalUtils.openDialog({
      dialog: this.dialog,
      dialogConfig: {
        width: 'auto',
        minWidth: '800px',
        height: 'auto',
        minHeight: '300px',
        enterAnimationDuration: '0ms',
        exitAnimationDuration: '0ms',
        disableClose: false,
      },
      component: GlobalConfigCesComponent,
      data: {
        type: TypeIndexEnum.CRUD,
        select: true,
      },
      callBack: (data: any) => { },
    });

    if (this.dialogRef) {
      this.dialogRef.close();
    }
  }
}
